import { environment } from '../../../environments/environment';

export class SETTINGS {
  public static ACCESS_TOKEN = '%&^%^*@&*#';
  public static REFRESH_TOKEN = '&@&#&$(@&##';
  public static USER_PRIVILEGES = '%$^%((*';
  public static USER_PERMISSIONS = ')(&^&%^$*&*&$&*()*';
  public static USER_ROLE = ')(&^&%^$*&**&^%^&&^&&$&*()*';
  public static LOGGED_IN_USER = '#$%@^^%';
  public static DEPARTMENT = '#$%@^^%((^(';
  public static DEPARTMENT_NAME = '#$^$^&*&%@^^%';

  public static BASE_API = environment.baseUrl; // do not change this

  public static KEYS = {
    SECRET: 'iIUsWtNZcf',
  };

  public static REGEX = {
    PASSWORD: {
      EXP: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$',
    },
    PHONE: {
      EXP: '^[0-9]{1,10}$',
    },
    ID: {
      EXP: '^[0-9]{9}v$',
    },
    LETTERS: {
      EXP: '[a-zA-Z\\s]*$',
    },
  };

  public static AVAILABILITY_STATUS = {
    AVAILABLE: 'AVAILABLE',
    ON_TRANSFER: 'ON_TRANSFER',
    OUT_OF_SERVICE: 'OUT_OF_SERVICE',
    ON_RENT: 'ON_RENT',
    ON_SERVICE: 'ON_SERVICE',
    ON_OTHER_TOUR: 'ON_OTHER_TOUR',
  };

  public static AVAILABILITY_STATUS_PAIRS = [
    { value: 'AVAILABLE', label: 'Available', bgColor: 'fleet-avail-c' },
    { value: 'ON_TRANSFER', label: 'On Transfer', bgColor: 'fleet-trans-c' },
    {
      value: 'OUT_OF_SERVICE',
      label: 'Out of Service',
      bgColor: 'fleet-outOfSer-c',
    },
    { value: 'ON_RENT', label: 'On Rent', bgColor: 'fleet-rent-c' },
    // { value: 'ON_SERVICE', label: 'On Service' },
    {
      value: 'ON_OTHER_TOUR',
      label: 'On Other Tour',
      bgColor: 'fleet-other-c',
    },
  ];
  public static DRIVER_AVAILABILITY_STATUS = [
    {
      value: 'ON_TRANSFER',
      label: 'On Transfer',
      colorCode: '#FF8C00',
      bgColor: 'driver-trans-c',
    },
    {
      value: 'ON_RENT',
      label: 'On Rent',
      colorCode: '#2A7CF5',
      bgColor: 'driver-rent-c',
    },
    {
      value: 'ON_OTHER_TOUR',
      label: 'On Other Tour',
      colorCode: '#ae1bf8',
      bgColor: 'driver-other-c',
    },
    {
      value: 'NOT_AVAILABLE',
      label: 'Not Available',
      colorCode: '#F3454C',
      bgColor: 'driver-notAvail-c',
    },
    {
      value: 'AVAILABLE',
      label: 'Available',
      colorCode: '#3ab200',
      bgColor: 'driver-avail-c',
    },
  ];

  public static WASH_STATUS = {
    WASHED: 'WASHED',
    DIRTY: 'DIRTY',
    READY: 'READY',
  };

  public static WASH_STATUS_PAIRS = [
    { value: 'WASHED', label: 'Washed' },
    { value: 'DIRTY', label: 'Dirty' },
    { value: 'READY', label: 'Ready' },
  ];

  public static DAMAGE_TYPES = [
    { value: 'SCRATCH', label: 'Scratch', no: 1 },
    { value: 'DENT', label: 'Dent', no: 2 },
    { value: 'BROKEN', label: 'Broken', no: 3 },
    { value: 'CRACKED', label: 'Cracked', no: 4 },
    { value: 'MISSING', label: 'Missing', no: 5 },
    { value: 'STAIN', label: 'Stain', no: 6 },
    { value: 'SMASHED', label: 'Smashed', no: 7 },
  ];

  public static RENT_BOOKING_TYPE = [
    { value: 'DIRECT_BOOKING', label: 'Direct booking (No agents)' },
    { value: 'THROUGH_AGENT', label: 'Through an Agent' },
  ];
  public static FUEL_TYPE = [
    { value: 'Diesel', label: 'Diesel' },
    { value: 'Electric', label: 'Electric' },
    { value: 'Petrol', label: 'Petrol' },
  ];
  public static TRANSMISSION_TYPE = [
    { value: 'Auto', label: 'Auto' },
    { value: 'Manual', label: 'Manual' },
  ];
  public static VEHICLE_BRAND_TYPE = [
    { value: 'Acura', label: 'Acura' },
    { value: 'Audi', label: 'Audi' },
    { value: 'Bentley', label: 'Bentley' },
    { value: 'Benz', label: 'Benz' },
    { value: 'BMW', label: 'BMW' },
    { value: 'Cadillac', label: 'Cadillac' },
    { value: 'Chevrolet', label: 'Chevrolet' },
    { value: 'Chrysler', label: 'Chrysler' },
    { value: 'DFSK', label: 'DFSK' },
    { value: 'Fiat', label: 'Fiat' },
    { value: 'Ford', label: 'Ford' },
    { value: 'Geely', label: 'Geely' },
    { value: 'Honda', label: 'Honda' },
    { value: 'Hummer', label: 'Hummer' },
    { value: 'Hyundai', label: 'Hyundai' },
    { value: 'Jaguar', label: 'Jaguar' },
    { value: 'Jeep', label: 'Jeep' },
    { value: 'Kia', label: 'Kia' },
    { value: 'Mazda', label: 'Mazda' },
    { value: 'MG', label: 'MG' },
    { value: 'Mini', label: 'Mini' },
    { value: 'Mitsubishi', label: 'Mitsubishi' },
    { value: 'Nissan', label: 'Nissan' },
    { value: 'Opel', label: 'Opel' },
    { value: 'Porsch', label: 'Porsch' },
    { value: 'Range Rover ', label: 'Range Rover ' },
    { value: 'Subaru', label: 'Subaru' },
    { value: 'Suzuki', label: 'Suzuki' },
    { value: 'Tata', label: 'Tata' },
    { value: 'Toyota', label: 'Toyota' },
    { value: 'Volkswagen ', label: 'Volkswagen ' },
    { value: 'Volvo', label: 'Volvo' },
  ];

  public static AGREEMENT_RENTING_PERIOD = [
    { value: 3, label: '03 Months' },
    { value: 6, label: '06 Months' },
    { value: 12, label: '12 Months' },
    { value: 'OTHER', label: 'Other' },
  ];
  public static AGREEMENT_ENTITLED_KMS = [
    { value: '3500', label: '3500' },
    { value: 'UNLIMITED', label: 'Unlimited' },
    { value: 'OTHER', label: 'Other' },
  ];
  public static MODULE_CATEGORY = [
    { value: 'USER', label: 'USER' },
    { value: 'FLEET', label: 'FLEET' },
    { value: 'DRIVER', label: 'DRIVER' },
    { value: 'SUPPLIER', label: 'SUPPLIER' },
    { value: 'CUSTOMER', label: 'CUSTOMER' },
    { value: 'AGENT', label: 'AGENT' },
    { value: 'BOOKING', label: 'BOOKING' },
  ];

  public static UPLOAD_PLACEHOLDER =
    'data:image/png;base64,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';
}
